<template>
    <div>
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">审核审批管理</div>
                        </el-col>
                    </el-row>
                    <el-row style="text-align: left">
                        <el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData">
                            <el-form-item >
                                <el-input @change="changeIndex"   placeholder="申请人" v-model="searchForm.sqrName" clearable >
                                </el-input>
                            </el-form-item>
                            <!-- <el-form-item >
                                <el-date-picker
                                        v-model="startTime"
                                        type="daterange"
                                        @change="changeIndex"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item> -->
                            <el-form-item >
                                <el-select v-model="searchForm.shType" clearable @change="changeIndex" placeholder="状态">
                                    <el-option v-if="shrylx == 'spr' || shrylx == 'shr-spr'" label="待审阅" value="dck"></el-option>
                                    <el-option v-if="shrylx == 'shr'" label="待审核" value="dsh"></el-option>
                                    <el-option v-if="shrylx == 'shr'" label="已审核" value="ysh"></el-option>
                                    <el-option v-if="shrylx == 'shspr' || shrylx == 'shr-spr'" label="待审批" value="dsh"></el-option>
                                    <el-option v-if="shrylx == 'shspr' || shrylx == 'shr-spr'" label="已审批" value="ysh"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="searchData()">查询</el-button>
                                <el-button v-if="shrylx == 'shr' || shrylx == 'shspr' || shrylx == 'shr-spr'"  type="success" @click="plShInfo('ty')">批量通过</el-button>
                                <el-button v-if="shrylx == 'shr' || shrylx == 'shspr' || shrylx == 'shr-spr'" type="danger" @click="plShInfo('jj')">批量驳回</el-button>
                                <el-button v-if="shrylx == 'spr' || shrylx == 'shr-spr'"  type="success" @click="plShInfo('ty')">批量审阅</el-button>
                            </el-form-item>
                        </el-form>
                    </el-row>
                </div>

                <el-table
                        :header-cell-class-name="handleHeaderClass"
                        @sort-change="handleTableSort"
                        :data="dataList" @selection-change="selectionChangeHandle" v-loading="loading"  style="text-align: center; width: 100%;">
                    <el-table-column
                            type="selection"
                            header-align="center"
                            align="center"
                            width="50">
                    </el-table-column>
                    <el-table-column prop="t.username" label="申请人" >
                        <template slot-scope="scope">
                            {{scope.row.username}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.type" label="类型"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.type == 'jb'">加班</span>
                            <span v-if="scope.row.type == 'qj'">请假</span>
                            <span v-if="scope.row.type == 'bk'">补卡</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.status" label="状态" >
                        <template slot-scope="scope">
                            <el-tag type="danger" v-if="shrylx == 'shr' && scope.row.shtype == 'dsh'">待审核</el-tag>
                            <el-tag type="success" v-if="shrylx == 'shr' && scope.row.shtype == 'ysh'">已审核</el-tag>
                            <el-tag type="danger" v-if="(shrylx == 'shspr' || shrylx == 'shr-spr') && scope.row.shtype == 'dsh'">待审批</el-tag>
                            <el-tag type="success" v-if="(shrylx == 'shspr' || shrylx == 'shr-spr') && scope.row.shtype == 'ysh'">已审批</el-tag>
                            <el-tag type="warning" v-if="(shrylx == 'shr-spr' && scope.row.shtype == 'dck') || scope.row.shtype == 'dck'">待审阅</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.time" label="申请时间" >
                        <template slot-scope="scope">
                            {{scope.row.tjsj}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.username" label="审核人" >
                        <template slot-scope="scope">
                            {{scope.row.shrxm}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.username" label="审批人" >
                        <template slot-scope="scope">
                            {{scope.row.sprxm}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" :render-header="renderHeader">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" v-if="scope.row.shtype == 'dck'"  @click="syInfo(scope.row)">审阅</el-button>
                            <el-button type="text" size="mini" v-if="(shrylx == 'shr') && scope.row.shtype == 'dsh'"  @click="shAndDetailsInfo(scope.row)">审核</el-button>
                            <el-button type="text" size="mini" v-if="(shrylx == 'shspr' || shrylx == 'shr-spr') && scope.row.shtype == 'dsh'"  @click="shAndDetailsInfo(scope.row)">审批</el-button>
                            <el-button type="text" size="mini" v-if="scope.row.shtype == 'ysh'"  @click="shAndDetailsInfo(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                </el-pagination>

                <el-dialog
                        style="text-align: left"
                        title="导出"
                        :visible.sync="exportVisible">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
                        <el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
                    </el-checkbox-group>
                    <form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/tpatrollog//export?access_token='+this.$store.getters.token" target="_blank">
                        <input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
                        <input type="hidden" name="fileds" value="" ref="fileds"/>
                    </form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="exportVisible = false">取 消</el-button>
                        <el-button type="primary" @click="exportExcel">确 定</el-button>
                    </span>
                </el-dialog>
            </el-card>
        </div>
        <bk-show-info v-if="bkShowState" ref="bkShowInfo" @refreshDataList="searchData"></bk-show-info>
        <jb-show-info v-if="jbShowState" ref="jbShowInfo" @refreshDataList="searchData"></jb-show-info>
        <qj-show-info v-if="qjShowState" ref="qjShowInfo" @refreshDataList="searchData"></qj-show-info>
    </div>
</template>
<script>
    import {
        Vue,
        Component
    } from 'vue-property-decorator'
    import BkShowInfo from './bkxx-info.vue'
    import JbShowInfo from './jbxx-info.vue'
    import QjShowInfo from './qjxx-info.vue'
    import Template from "../../../template";
    const exportFields=[
        {name:'工号',value:'workNumber'},
        {name:'用户名',value:'userName'},
        {name:'部门',value:'bmmc'},
        {name:'岗点',value:'gdmc'},
        {name:'巡逻点',value:'plcaeName'},
        {name:'详细地址',value:'detailPlace'},
        {name:'时间',value:'time'}
    ]
    @Component({
        name: 'shspgl',
        components:{
            Template,
            BkShowInfo,
            JbShowInfo,
            QjShowInfo
        }
    })
    export default class shspgl extends Vue {
        currentNo = 1;
        pageSize = 10;
        pageTotal = 0;
        dataList=[]
        bkShowState=false
        jbShowState=false
        qjShowState=false
        startTime=[]
        searchForm={
            sqrName:'',
            startTimest: '',
            startTimeed: '',
            orders:'',
            shtype:''
        }
        loading = false;
        dataListSelections=[];
        orders=[]
        exportVisible = false;
        isIndeterminate= false
        checkAll=false;
        fields=exportFields;
        filedValues=exportFields.map(item => item.value);
        fieldList=[];
        shrylx='shr';
        shLoding= false;

        created() {
          this.searchData();
        }

        getParams() {
            if(this.startTime &&this.startTime.length==2){
                this.searchForm.startTimest = this.startTime[0]
                this.searchForm.startTimeed = this.startTime[1]
            } else{
                this.searchForm.startTimest = ''
                this.searchForm.startTimeed = ''
            }
            this.searchForm.orders = encodeURI(JSON.stringify(this.orders));
            this.searchForm.pageNum = this.currentNo;
            this.searchForm.pageSize = this.pageSize
        }

        searchData () {
            this.loading = true
            this.getParams()
            this.$request.get('/bjba/xxsh/getAllSHListByPagePC',{
                params:this.searchForm
            }).then(res => {
                console.log("查询审核信息为：",res)
                const {data} = res
                this.loading = false
                this.dataList = data.data
                this.pageTotal = data.total
                this.shrylx = data.shrylx
                // this.shStatus = this.searchForm.status
                // if (this.searchForm.status == 'dsh') {
                //     this.dataList = data.DSHdata
                //     this.pageTotal = data.DSHdata.length
                // } else if (this.searchForm.status == 'ysh') {
                //     this.dataList = data.YSHdata
                //     this.pageTotal = data.YSHdata.length
                // } else if (this.searchForm.status == 'dck') {
                //     this.dataList = data.DCKdata
                //     this.pageTotal = data.DCKdata.length
                // } 
            }).catch(err => {
                this.$message({
                    message: '获取数据出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
                this.loading = false
                console.log(err)
            })
        }

        changeIndex(){
            this.currentNo =1
        }

        handleSizeChange(val) {
            this.pageSize = val;
            this.searchData();
        }
        handleCurrentChange(val) {
            this.currentNo = val;
            this.searchData();
        }

        // 设置列的排序为我们自定义的排序
        handleHeaderClass({ column }) {
            if(!column.multiOrder) column.multiOrder =''
            column.order = column.multiOrder
        }
        
        // 表格数据排序
        handleOrderChange (orderColumn, orderState) {
            let result = this.orders.find(e => e.orderColumn === orderColumn)
            if (result) {
                if(orderState)
                    result.orderState = orderState
                else {
                    var j =this.orders.indexOf(result);
                    if(j !== -1) {
                        this.orders.splice(j,1);
                    }
                }
            } else {
                this.orders.push({
                    orderColumn: orderColumn,
                    orderState: orderState
                })
            }
            this.searchData()
        }
        // 上面排序的缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
        // 列表排序
        handleTableSort({ column }) {
            column.multiOrder = column.order
            this.handleOrderChange(column.property, column.multiOrder)
        }

        // 多选
        selectionChangeHandle (val) {
            this.dataListSelections = val
        }

        // 表头导出按钮
        renderHeader (h) {
            // return (
            //         <div class="clearfix">
            //         <span>操作</span>
            //         <el-button style="padding:5px;float:right" size="mini"
            // onClick={()=>this.showExportDialog()}>导出</el-button></div>
            // )
        }
        showExportDialog() {
            this.exportVisible = true
        }
        handleCheckAllChange(val) {
            this.fieldList = val ? this.filedValues: [];
            this.isIndeterminate = false;
        }
        handleCheckedItemChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.filedValues.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
        }
        exportExcel() {
            var filedLast = this.fields.filter(filed=>{
                return this.fieldList.indexOf(filed.value) !==-1
            })
            if(filedLast && filedLast.length>0) {
                this.getParams();
                this.$refs.fileds.value = JSON.stringify(filedLast)
                this.$refs.exportForm.submit();
            } else {
                this.$message({
                    message: '请选择字段',
                    type: 'error',
                    duration: 1500
                })
                return
            }
        }

        syInfo(val) {
            var url = '';
            if (val.type == 'jb') {
                url = '/bjba/toUpdateJBXX';
            } else if (val.type == 'qj') {
                url = '/bjba/toUpdateQJXX';
            } else if (val.type == 'bk') {
                url = '/bjba/toUpdateBKXX';
            }
            this.$request.get(url,{
                params: {
                    id: val.id
                }
            }).then(res => {
                console.log("审批返回信息为：",res)
                this.searchData()
                const {data} = res
                data.shtype = val.shtype
                if (val.type == 'bk') {
                    this.bkShowState = true
                    this.$nextTick(() => {
                        this.$refs.bkShowInfo.init(data)
                    })
                } else if (val.type == 'jb') {
                    this.jbShowState = true
                    this.$nextTick(() => {
                        this.$refs.jbShowInfo.init(data)
                    })
                } else if (val.type == 'qj') {
                    this.qjShowState = true
                    this.$nextTick(() => {
                        this.$refs.qjShowInfo.init(data)
                    })
                } 
            }).catch(err => {
                this.$message({
                    message: '审批出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
                console.log(err)
            })
        }

        // 表格数据详情展示
        shAndDetailsInfo(val) {
            console.log("点击详情数据：",val)
            var url = '';
            if (val.type == 'bk') {
                url = '/bjba/getBKXX';
            } else if (val.type == 'jb') {
                url = '/bjba/getJBXX';
            } else if (val.type == 'qj') {
                url = '/bjba/getQJXX';
            } 
            this.$request.get(url,{
                params: {
                    id: val.id
                }
            }).then(res => {
                console.log("查询审核信息--详情为：",res)
                const {data} = res
                data.shtype = val.shtype
                if (val.type == 'bk') {
                    this.bkShowState = true
                    this.$nextTick(() => {
                        this.$refs.bkShowInfo.init(data)
                    })
                } else if (val.type == 'jb') {
                    this.jbShowState = true
                    this.$nextTick(() => {
                        this.$refs.jbShowInfo.init(data)
                    })
                } else if (val.type == 'qj') {
                    this.qjShowState = true
                    this.$nextTick(() => {
                        this.$refs.qjShowInfo.init(data)
                    })
                } 
            }).catch(err => {
                this.$message({
                    message: '获取数据出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
                console.log(err)
            })
        }

        plShInfo(type) {
            if(this.dataListSelections.length==0) return
            var msg = ''
            if (type == 'ty') {
                msg = '批量通过'
            } else {
                msg = '批量驳回'
            }
            this.$confirm(`确定进行[`+msg+`]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.shLoding = this.$loading({
                    lock: true,
                    text: '正在审核中，请耐心等待...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http({
                    url: type === 'ty'?'/bjba/xxsh/batchPass/':'bjba/xxsh/batchRejection/',
                    method: 'post',
                    data: this.dataListSelections
                }).then(({data}) => {
                    this.shLoding.close();
                    if (data && data.code === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.searchData()
                    } else if(data && data.code ==500) {
                        this.$message({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                }).catch(() => {
                    this.shLoding.close();
                })
            }).catch(() => {
            })
        }

        // plShInfo(type) {
        //     let ids = this.dataListSelections.map(item => {
        //         return item.id
        //     })
        //     if(ids.length==0) return
        //     var msg = ''
        //     if (type == 'ty') {
        //         msg = '批量通过'
        //     } else {
        //         msg = '批量驳回'
        //     }
        //     this.$confirm(`确定进行[`+msg+`]操作?`, '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         this.$http({
        //             url: type === 'ty'?'/bjba/xxsh/batchPass/':'bjba/xxsh/batchRejection/',
        //             method: 'post',
        //             data: ids
        //         }).then(({data}) => {
        //             if (data && data.code === 200) {
        //                 this.$message({
        //                     message: '操作成功',
        //                     type: 'success',
        //                     duration: 1500
        //                 })
        //                 this.searchData()
        //             } else if(data && data.code ==500) {
        //                 this.$message({
        //                     message: data.message,
        //                     type: 'error',
        //                     duration: 1500
        //                 })
        //             }
        //         })
        //     }).catch(() => {
        //     })
        // }
    }
</script>

<style lang="scss" scoped>

</style>
